import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  List,
  ListItem,
  ListItemText,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function VersionConflictDialog({ 
  open, 
  conflictItem, 
  currentIndex,
  totalConflicts,
  onResponse 
}) {
  const { t } = useTranslation();

  const handleResponse = (decision) => {
    onResponse(decision);
  };

  if (!conflictItem) {
    return null;
  }
  const typeMap = {
    INBOUND: "inbound_templates",
    OUTBOUND: "outbound_templates",
    WORKFLOW: "",
    inboundTemplate: "inbound_templates",
    outboundTemplate: "outbound_templates",
    workflow: "",
  };
  return (
    <Dialog
      open={open}
      onClose={() => handleResponse("NO")}
      maxWidth="sm"
      // className="dialog-top"
      // fullWidth
      disableEscapeKeyDown>
      <DialogTitle className="dialog-header">
        <div className="flex space-between align-center">
          <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
            {t("BOX_WARN") || "Warning"} ({currentIndex + 1} of {totalConflicts})
          </Typography>
          <IconButton
            onClick={() => handleResponse("NO")}
            sx={{ borderRadius: "5px" }}
          >
            <CloseIcon 
              sx={{
                height: "28px",
                width: "28px",
                color: "#777777",
              }}
            />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent className="dialog-content" dividers>
        <Typography variant="body1" sx={{ mb: 2, fontWeight: "bold" }}>
          {t("BOX_REPLACE_NEWER_WITH_OLDER_ON_SERVER_CAPTION") ||
            "Replace newer version on server with older client version?"}
        </Typography>

        <Typography variant="body2" sx={{ mb: 2 }}>
          {t("BOX_REPLACE_NEWER_WITH_OLDER_MSG") || "The following item has a newer version on the server. Do you want to replace it with your older version?"}
        </Typography>

        <List
          dense
          sx={{
            bgcolor: "#fafafa",
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            mb: 2,
            maxHeight: "150px",
            overflow: "auto",
          }}>
          <ListItem sx={{ py: 1 }}>
            <ListItemText
              primary={
                <Typography variant="body2" sx={{ fontWeight: "medium" }}>
                  {conflictItem.name || conflictItem.title}
                </Typography>
              }
              secondary={
                <div>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block" }}>
                    Path: {conflictItem.path || `${conflictItem.workflowGroup || ""}${
                      conflictItem.workflowGroup ? "/" : ""
                    }${typeMap[conflictItem.type] ? typeMap[conflictItem.type] + "/" : ""}${conflictItem.title}`}
                  </Typography>
                  {conflictItem.error && (
                    <Typography
                      variant="caption"
                      color="error"
                      sx={{ display: "block", mt: 0.5 }}>
                      {conflictItem.error}
                    </Typography>
                  )}
                  {(conflictItem?.templateRevisionId || conflictItem?.userspace?.localRevisionId) && (conflictItem?.serverRevisionId || conflictItem?.server?.revisionId) && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", mt: 0.5 }}>
                      Template revision: {conflictItem?.templateRevisionId || conflictItem?.userspace?.localRevisionId}, Server revision: {conflictItem?.serverRevisionId || conflictItem?.server?.revisionId}
                    </Typography>
                  )}
                </div>
              }
            />
          </ListItem>
        </List>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "flex-end", px: 3, py: 2 }}>
        <div>
          <Button
            onClick={() => handleResponse("YES")}
            variant="outlined"
            color="primary"
            sx={{ mr: 1 }}>
            {t("BTN_YES") || "Yes"}
          </Button>
          <Button
            onClick={() => handleResponse("YES_TO_ALL")}
            variant="outlined"
            color="primary"
            sx={{ mr: 1 }}>
            {t("BTN_YES_TO_ALL") || "Yes To All"}
          </Button>
          <Button
            onClick={() => handleResponse("NO")}
            variant="outlined"
            sx={{ mr: 1 }}>
            {t("BTN_NO") || "No"}
          </Button>
          <Button
            onClick={() => handleResponse("NO_TO_ALL")}
            variant="outlined"
            color="primary"
            sx={{ mr: 1 }}>
            {t("BTN_NO_TO_ALL") || "No To All"}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default VersionConflictDialog;
